import _ from 'lodash';
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

export function PasswordLevelValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
        const utils = window['utils'];
        if(utils.checkPassStrength(control.value) === 'weak') {
            return { weak: true};
        }
        return null;
    };
}